import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MessagingService } from "./messaging.service";
import { environment } from "src/environments/environment";

@Injectable()
export class SignalingService {
    public timelineTopicName: string = 'note';
    public camerasTopicName: string = 'cameras';
    public camerasCaseTopicName: string = 'camera-case'; // used for case updated on camera table
    public threatTopicName: string = 'threat';
    public materialTopicName: string = 'material';
    public livePinsTopicName: string = 'live-pins';
    public antennaTopicName: string = 'antennabasedlocation';
    public routeTopicName: string = 'route';
    public weaponDetectedTopicName: string = 'weapon-detected';
    public assignInvestigatorsTopicName: string = 'assign-investigators';
    public assignCamerasTopicName: string = 'assign-cameras';
    public assignBuildingsTopicName: string = 'assign-buildings';
    public indoorAlertsTopicName: string = 'indoor-alerts';
    public siteMapTopicName: string = 'site-map';
    public pinUserTopicName: string = 'pin-user';
    public isConnected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public signal: any = undefined;

    private env: string = 'local';

    constructor(private messagingService: MessagingService) {
        this.env = environment.environment == 'local' ? 'staging' : environment.environment;
        this.messagingService.isConnected.subscribe(v => this.isConnected.next(v));
    }

    async init() {
        await this.messagingService.init();
    }

    publish(messageName: string, payload: any, channelName: string, callBack?: any) {
        this.messagingService.publish(messageName, channelName, payload).then(() => {
            // console.log('message published', { messageName, channelName, payload });
            if (callBack) callBack();
        }).catch(() => { });
    }

    subscribe(messageName: string, channelName: string, callBack: (message: any) => void) {
        this.messagingService.subscribe(messageName, channelName, callBack);
    }

    unsubscribe(topic: string, channelName: string, callback?: (message: any) => void) {
        this.messagingService.unsubscribe(topic, channelName, callback);
    }

    disconnect() {
        this.messagingService.disconnect();
    }

    getChannel(name: string) {
        return undefined;
    }

    leaveChannel(name: string) {
        return;
    }

    close() {
        this.disconnect();
    }
}
